<template>
  <form class="my-5 mx-5">
    <b-form-group v-if="!userToEdit" id="first_name" :label="$t($getConst.pages.personalDetails.first_name)"
                  label-for="first_name-input">
      <b-form-input
        id="first_name-input"
        v-model.trim="$v.user.firstName.$model"
        :class="{ 'is-invalid': $v.user.firstName.$error }"
        :placeholder="$t(this.$getConst.pages.personalDetails.firstName_placeholder)"
        size="lg"
        required
      ></b-form-input>
      <AppFormFeedback :errors="$v.user.firstName"/>
    </b-form-group>
    <b-form-group v-if="!userToEdit" id="last_name" :label="$t($getConst.pages.personalDetails.last_name)"
                  label-for="last_name-input">
      <b-form-input
        id="last_name-input"
        v-model.trim="$v.user.lastName.$model"
        :class="{ 'is-invalid': $v.user.lastName.$error }"
        :placeholder="$t(this.$getConst.pages.personalDetails.lastName_placeholder)"
        size="lg"
        required
      ></b-form-input>
      <AppFormFeedback :errors="$v.user.lastName"/>
    </b-form-group>
    <b-form-group v-if="!userToEdit" id="email" :label="$t($getConst.pages.pageUsers.email)" label-for="email-input">
      <b-form-input
        id="email-input"
        @input="userExist = false"

        v-model.trim="$v.user.email.$model"
        :class="{ 'is-invalid': $v.user.email.$error || userExist }"
        :placeholder="$t(this.$getConst.pages.personalDetails.email_placeholder)"
        size="lg"
        required
      ></b-form-input>
      <AppFormFeedback :errors="$v.user.email"/>
      <b-form-invalid-feedback v-if="userExist">
        {{$t(this.$getConst.pages.form.exist_field_error)}}.
      </b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="!$v.user.email.admHaveHays">
        {{$t(this.$getConst.pages.form.admin_email_hays)}}.
      </b-form-invalid-feedback>
    </b-form-group>
    <div v-if="userToEdit">
      <label>{{$t($getConst.pages.pageUsers.id)}}</label>
      <p>{{userEdited.id}}</p>
      <label>{{$t($getConst.pages.pageUsers.name)}}</label>
      <p>{{userEdited.name}}</p>
      <label>{{$t($getConst.pages.pageUsers.email)}}</label>
      <p>{{userEdited.email}}</p>
    </div>
    <label>{{$t($getConst.pages.pageUsers.role)}}</label>
    <div v-if="userToEdit">
      <ul v-if="userToEdit.roles.length > 1">
        <li v-for="role in userToEdit.roles">
          {{ role.name }}
        </li>
      </ul>
      <template
        v-else-if="userToEdit.role.name==='Worker'||userToEdit.role.name==='Approver'||userToEdit.role.name==='Vendor'||userToEdit.role.name==='Freelancer'">
        <p>{{userEdited.role.name}}</p>
      </template>
    </div>
    <b-form-group id="role" label-for="role-input"
       v-if="!((userToEdit)&&(userToEdit.role.name==='Worker'||userToEdit.role.name==='Approver'||userToEdit.role.name==='Vendor'||userToEdit.role.name==='Freelancer'))"
    >
      <multiselect
        v-model="$v.user.role_id.$model"
        :class="{ 'is-invalid': $v.user.role_id.$error }"
        track-by="id"
        label="name"
        :placeholder="$t(this.$getConst.pages.form.select_option)"
        :options="allRole"
        @input="updateListOfScopes(true)"
      >
        <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
      </multiselect>
      <AppFormFeedback :errors="$v.user.role_id"/>
    </b-form-group>

    <b-form-group id="scopes" :label="$t($getConst.pages.pageUsers.scopes)+':'" label-for="scope-input">
      <multiselect
        v-model="$v.user.scopes.$model"
        :class="{ 'is-invalid': $v.user.scopes.$error }"
        track-by="id"
        label="name"
        :placeholder="$t(this.$getConst.pages.form.select_option)"
        :options="scopesOfSelectedRole"
        :multiple="true"
        @input="onChangeScopes"
      >
        <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
      </multiselect>
      <AppFormFeedback :errors="$v.user.scopes"/>
    </b-form-group>
    <b-form-group id="default_scope" :label="$t($getConst.pages.pageUsers.default_scope)+':'" label-for="scope-input">
      <multiselect
        v-model="$v.user.scope_id.$model"
        :class="{ 'is-invalid': $v.user.scope_id.$error || scopeExistInList}"
        track-by="id"
        label="name"
        :placeholder="$t(this.$getConst.pages.form.select_option)"
        :options="$v.user.scopes.$model"
      >
        <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
      </multiselect>
      <AppFormFeedback :errors="$v.user.scope_id"/>
      <b-form-invalid-feedback v-if="scopeExistInList">
        {{$t(this.$getConst.pages.personalDetails.notAssigned_scope_error)}}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group id="nav" :label="$t($getConst.pages.personalDetails.nav_id) + ' ' + user.scope_id.name" label-for="nav-input"
                  v-if="!userToEdit && user.scope_id && user.role_id && (user.role_id.id === 3 || user.role_id.id === 4)">
      <b-form-input
        v-model="user.nav_id"
        id="nav-input"
        :placeholder="$t(this.$getConst.pages.personalDetails.nav_id_placeholder)"
        size="lg"
      ></b-form-input>
    </b-form-group>
    <template v-if="user.scope_id && user.role_id && user.role_id.id === 5">
        <b-form-group id="vendor_gp_id" :label="$t($getConst.pages.personalDetails.vendor_gp_id) + ' ' + user.scope_id.name"
                      label-for="vendor_gp_id-input">
          <multiselect v-model.trim="user.vendor_id"
                       :placeholder="$t($getConst.pages.form.select_option)" :options="vendorIds"
                       :multiple="true" openDirection="top"
                       :searchable="true" :close-on-select="true"
                       :options-limit="300" :limit="6"
                       :max-height="300" :show-no-results="false"
                       @search-change="debounceVendors"
                       @input="changeVendorName"
                       :tag-placeholder="$t($getConst.pages.personalDetails.add_new_vendor)"
                       :taggable="true"
                       @tag="addNewVendor"

          >
            <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
          </multiselect>
        </b-form-group>
      <b-form-group v-if="user.vendor_name" id="vendor_name"
                    :label="$t($getConst.pages.personalDetails.vendor_name) + ' ' + user.scope_id.name">
        <ul>
            <li v-for="element in vendor_name_list" :key="element.gp_id">{{element.gp_id}} - {{element.name}}</li>
        </ul>

      </b-form-group>

    </template>

  </form>
</template>

<script>
  import {required} from "vuelidate/lib/validators";
  import {assignUsersRoleScopes, addUserByAdmin, getVendorsByScope} from "../../api/user.api";
  import {getAllScopes} from "../../api/scopes.api";
  import {getAllRoles} from "../../api/role.api";
  import AppFormFeedback from "../../components/common/form/AppFormFeedback";
  import {debounce} from "lodash";

  export default {
    name: "UserForm",
    components: {AppFormFeedback},
    data() {
      return {
        isLoading: false,
        userExist: false,
        scopeExistInList: false,
        user: {
          firstName: null,
          lastName: null,
          email: null,
          role_id: null,
          nav_id: null,
          vendor_id: null,
          vendor_name: null,
          scope_id: null,
          scopes: [],

        },
        allRole: [],
        allScope: [],
        scopesOfSelectedRole: [],
        userScopes: [],
        isSubmited: false,
        userEdited: this.userToEdit,
        vendors: [],
        vendorIds: [],
        getVendorsIsLoading: false
      }
    },
    props: {
      modal_id: null,
      userToEdit: null
    },
    validations() {
      if (this.userToEdit) {
        return {
          user: {
            role_id: {required},
            scope_id: {required},
            scopes: {required}
          }
        }
      } else {
        return {
          user: {
            firstName: {required},
            lastName: {required},
            email: {required, admHaveHays: (value) => {
                let ret = true
                if (this.user.role_id) {
                  if ([1, 2].includes(this.user.role_id.id) && !value.includes("@hays.")) {
                    ret = false
                  }
                }
                return ret
              }
            },
            role_id: {required},
            scope_id: {required},
            scopes: {required}
          }
        }
      }
    },
    computed: {
      vendor_name_list() {
        let vendor_display = []
        this.user.vendor_id.forEach(el=>{
          let vendor = this.user.vendor_name.find(item => item.gp_id==el)
          if (vendor) {
            vendor_display.push(vendor);
          }
        })
        return vendor_display
      }
    },
    created() {
      this.getScopes();
      this.getRoles();
      if (this.userToEdit) {
        this.user.role_id = this.userToEdit.role;
        this.user.scopes = this.userToEdit.scopes;
        this.user.scope_id = this.userToEdit.scopeDefault;
      }
      this.debounceVendors = debounce((query) => this.getVendorsByScope(query), 1000);
    },
    async mounted() {
      this.$root.$on('isSubmited', submit => {
        this.isSubmited = submit;
      });
      if (this.userToEdit && this.userToEdit.vendor_id) {
          this.user.vendor_id = this.userToEdit.vendor_id;
          this.user.vendor_name = this.userToEdit.vendor_id_name;
      }
    },
    methods: {
      closeModal() {
        this.$bvModal.hide(this.modal_id)
      },
      getScopes() {
        getAllScopes().then(
          res => {
            this.allScope = res.data;
            this.updateListOfScopes();
          },
          error => this.handleApiError(error)
        );
      },
      getRoles() {
        getAllRoles().then(
          res => {
            if(this.userToEdit){
              this.allRole = res.data.data.filter(role => ["Super Admin","Local Admin"].includes(role.name));
            } else {
              this.allRole = res.data.data;
            }
          },
          error => this.handleApiError(error)
        );
      },
      isFormInvalid() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.isSubmited = false;
          return true;
        }
        return false
      },
      errorFromServerTreatment(error){

        if ( error.response.data.code === 422) {
         this.userExist = true;
          this.isSubmited = false;
          this.scopeExistInList = 'default_scope' in error.response.data.error?true:false;


        }
        this.$root.$emit('isLoading', false);
        this.isSubmited = false;
      },

      formValidTreatment() {
        this.$root.$emit('isLoading', true);
        this.userExist = false;
        this.user.scopes.forEach(scope => {
          this.userScopes.push(scope.id);
        });
        let user = Object.assign({}, this.user);
        user.scopes = this.userScopes;
        user.role_id = this.user.role_id.id;
        user.scope_id = this.user.scope_id.id;
        return user;
      },
      assignUserRoleScopes() {
        if (this.isFormInvalid()) {
          return;
        }
        assignUsersRoleScopes(this.userToEdit.id, this.formValidTreatment()).then(
          res => {
            this.$root.$emit('onEditUser', res.data);
            this.$root.$emit('isLoading', false);
            this.closeModal()
          },
          error => {
            this.handleApiError(error);
            this.errorFromServerTreatment(error);
          }
        )
      },
      addUserByAdmin() {
        if (this.isFormInvalid()) {
          return;
        }
        addUserByAdmin(this.formValidTreatment()).then(
          res => {
            this.isSubmited = false;
            this.$root.$emit('onAddUser', res.data);

            this.$root.$emit('isLoading', false);
            this.closeModal();
          },
          error => {
            if (error.response.data.code === 422) {
              this.userExist = true;
              this.isSubmited = false;
            }
            this.$root.$emit('isLoading', false);
            this.handleApiError(error);

          }
        )
      },
      updateListOfScopes(refreshUserScopes = false){
        if (refreshUserScopes) {
          this.user.scopes = [];
          this.user.scope_id = null;
        }
        if(this.user.role_id && ["Worker","Approver"].includes(this.user.role_id.name)){
          this.scopesOfSelectedRole=this.allScope.filter(scope => scope.is_timesheets_enabled === true);
        }
        else if(this.user.role_id && this.user.role_id.name==="Vendor"){
          this.scopesOfSelectedRole=this.allScope.filter(scope => scope.is_invoices_enabled === true);
        }
        else if(this.user.role_id && this.user.role_id.name==="Freelancer"){
          this.scopesOfSelectedRole=this.allScope.filter(scope => scope.is_freelancers_enabled === true);
        }
        else {
          this.scopesOfSelectedRole = this.allScope;
        }
      },
      async getVendorsByScope(query) {
        if (query.length > 0) {
          this.getVendorsIsLoading = true;
          await getVendorsByScope(this.user.scope_id.id, {vendor_gp_id: query}).then(
            response => {
              this.vendorIds = response.data.vendorIds;
              this.vendors = response.data.vendors;
              this.getVendorsIsLoading = false;
            },
            error => {
              this.handleApiError(error);
              this.getVendorsIsLoading = false;
            }
          );
        }
      },
      changeVendorName(value) {
        // this.user.vendor_name = []
        this.vendors
          .filter(vendor => value.includes(vendor.gp_id))
          .forEach(el => {
            this.user.vendor_name.push(
              {gp_id: el.gp_id, name: el.name}
            )
          })
      },
      addNewVendor(newVendor) {
        this.vendorIds.push(newVendor);
        this.user.vendor_id.push(newVendor);
      },
      onChangeScopes() {
        if (!this.user.scopes.includes(this.user.scope_id)) {
          this.user.scope_id = null;
        }
      },
    },
    watch: {
      isSubmited: function () {
        if(this.isSubmited == true) {
          if (this.userToEdit) {
            this.assignUserRoleScopes();
          } else {
            this.addUserByAdmin();
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
